import { db, auth } from '../../firebase/config.js'
import { collection, addDoc, query, orderBy, getDocs, where } from 'firebase/firestore'

export function useExportHistory() {
    const logPdfExport = async (examId, metadata = {}) => {
        if (!auth.currentUser) {
            console.warn('Cannot log export: User not authenticated')
            return null
        }

        try {
            const exportData = {
                type: 'pdf_export',
                fileName: metadata.fileName || `buletin_ecografie_${examId}.pdf`,
                examId: examId,
                patientNameSnapshot: metadata.patientName || '',
                doctorNameSnapshot: metadata.doctorName || auth.currentUser.email,
                dateConsult: metadata.dateConsult || '',
                createdBy: auth.currentUser.uid,
                createdByEmail: auth.currentUser.email,
                status: 'generated_local',
                note: 'PDF generated locally, not uploaded to cloud storage',
                createdAt: new Date().toISOString(),
                timestamp: Date.now()
            }

            const exportsRef = collection(db, 'exports')
            const docRef = await addDoc(exportsRef, exportData)

            return {
                id: docRef.id,
                ...exportData
            }
        } catch (error) {
            console.error('Error logging PDF export:', error)
            throw error
        }
    }

    const getExamExportHistory = async (examId) => {
        try {
            const exportsRef = collection(db, 'exports')
            const q = query(
                exportsRef,
                where('examId', '==', examId),
                orderBy('createdAt', 'desc')
            )
            
            const snapshot = await getDocs(q)
            return snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }))
        } catch (error) {
            console.error('Error getting exam export history:', error)
            throw error
        }
    }

    const getUserExportHistory = async (maxResults = 50) => {
        if (!auth.currentUser) {
            return []
        }

        try {
            const exportsRef = collection(db, 'exports')
            const q = query(
                exportsRef,
                where('createdBy', '==', auth.currentUser.uid),
                orderBy('createdAt', 'desc')
            )
            
            const snapshot = await getDocs(q)
            const results = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }))

            return results.slice(0, maxResults)
        } catch (error) {
            console.error('Error getting user export history:', error)
            throw error
        }
    }

    const getRecentExports = async (maxResults = 100) => {
        try {
            const exportsRef = collection(db, 'exports')
            const q = query(
                exportsRef,
                orderBy('createdAt', 'desc')
            )
            
            const snapshot = await getDocs(q)
            const results = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }))

            return results.slice(0, maxResults)
        } catch (error) {
            console.error('Error getting recent exports:', error)
            throw error
        }
    }

    return {
        logPdfExport,
        getExamExportHistory,
        getUserExportHistory,
        getRecentExports
    }
}
